"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_LOCATION = void 0;
const WIDGET_LOCATION = exports.WIDGET_LOCATION = 'widgetLocation';